import {Component} from '@angular/core';
import {LanguageSelector} from "../language-selector/language-selector.component";
import {LogoService} from "../../services/logo.service";

/** Site header */
@Component({
	selector: 'app-header',
	imports: [
		LanguageSelector
	],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss'
})
export class HeaderComponent {
	constructor(private logoService:LogoService) {

	}

	/** Get the current survey logo url for the top bar */
	get logo() {
		return this.logoService.currentLogo;
	}
}
